import { Link } from "@tanstack/react-router";

export function Footer() {
  return (
    <footer className="border-t border-border bg-white">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 md:grid-cols-4 lg:px-8">
        <div className="md:col-span-2">
          <img src="/assets/images/logo.webp" alt="QT Foods" width={300} height={100} className="h-10 w-[120px]" />
          <p className="mt-5 max-w-md text-base leading-relaxed text-muted-foreground">
            QT Foods is a wholesale and private-label partner for premium Japanese tea and teaware.
            We supply roasters, hospitality groups and retailers worldwide.
          </p>
          <div className="mt-6 text-sm text-muted-foreground">
            <p>QT FOODS CO., LTD.</p>
            <p>2-12-5, IZUMI EBINA-SHI, KANAGAWA-KEN,</p>
            <p>243-0437, JAPAN</p>
            <p>Tel: +81-46-236-1444</p>
            <p>Fax: +81-46-236-1565</p>
          </div>
        </div>
        <div>
          <h2 className="text-sm font-medium uppercase tracking-[0.18em] text-muted-foreground">
            Catalog
          </h2>
          <ul className="mt-4 space-y-2 text-base">
            <li>
              <Link to="/collections" className="hover:text-primary">
                All categories
              </Link>
            </li>
            <li>
              <Link to="/wholesale" className="hover:text-primary">
                Wholesale program
              </Link>
            </li>
            <li>
              <Link to="/inquiry" className="hover:text-primary">
                My inquiry
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h2 className="text-sm font-medium uppercase tracking-[0.18em] text-muted-foreground">
            Company
          </h2>
          <ul className="mt-4 space-y-2 text-base">
            <li>
              <Link to="/about" className="hover:text-primary">
                About
              </Link>
            </li>
            <li>
              <Link to="/private-label" className="hover:text-primary">
                Private Label
              </Link>
            </li>
            <li>
              <Link to="/certifications" className="hover:text-primary">
                Certifications
              </Link>
            </li>
            <li>
              <Link to="/journal" className="hover:text-primary">
                Journal
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-primary">
                Contact
              </Link>
            </li>
            <li>
              <a href="/assets/docs/privacy-policy.pdf" target="_blank" rel="noopener noreferrer" className="hover:text-primary">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="/assets/docs/commercial-disclosure.pdf" target="_blank" rel="noopener noreferrer" className="hover:text-primary">
                Commercial Disclosure
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="mx-auto flex max-w-7xl flex-col justify-between gap-2 px-5 py-5 text-sm text-muted-foreground md:flex-row lg:px-8">
          <span>© {new Date().getFullYear()} QT FOODS CO., LTD. All rights reserved.</span>
          <span>Wholesale & private-label inquiries: sales@qtfoods.co.jp</span>
        </div>
      </div>
    </footer>
  );
}
